import { useEffect } from "react";
import { Col, Row, Typography, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import styles from "./About.module.scss";
import about1 from "../../../Assets/PNG/about1.webp";
import about2 from "../../../Assets/PNG/about2.webp";
import about3 from "../../../Assets/PNG/about3.webp";

const { Title, Paragraph } = Typography;

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.aboutPage}>
      {/* Breadcrumb */}
      <div className={styles.breadcrumbBar}>
        <div className={styles.breadcrumbInner}>
          <Breadcrumb
            className={styles.breadcrumb}
            items={[
              { title: <Link to="/">Home</Link> },
              { title: "Our Story" },
            ]}
          />
        </div>
      </div>

      {/* Page Heading */}
      <div className={styles.header}>
        <span className={styles.eyebrow}>The Diamond Counter</span>
        <Title level={2} className={styles.pageTitle}>
          Our Story
        </Title>
        <div className={styles.headingLine} />
      </div>

      <Row justify="center">
        <Col xs={22} md={22} lg={20} xl={18} xxl={18}>
          {/* Section 1 */}
          <div className={styles.section}>
            <Row gutter={[40, 24]} align="middle">
              <Col xs={24} lg={12}>
                <div className={styles.textBlock}>
                  <Title level={3} className={styles.sectionTitle}>
                    A Legacy of Craftsmanship
                  </Title>
                  <Paragraph className={styles.sectionText}>
                    Rooted in a tradition of fine craftsmanship, our house was founded on a simple yet enduring
                    vision: to create jewellery that transcends time. What began as a family's devotion to the art
                    of fine jewellery has evolved into a name renowned for its integrity, artistry, and elegance.
                  </Paragraph>
                  <Paragraph className={styles.sectionText}>
                    Every piece that leaves our workshop carries with it decades of accumulated knowledge,
                    passed down through generations of master craftsmen who understand that true luxury
                    lies in the details.
                  </Paragraph>
                </div>
              </Col>
              <Col xs={24} lg={12}>
                <div className={styles.imageWrap}>
                  <img src={about1} alt="Legacy craftsmanship" className={styles.image} />
                </div>
              </Col>
            </Row>
          </div>

          {/* Section 2 */}
          <div className={styles.section}>
            <Row gutter={[40, 24]} align="middle">
              <Col xs={24} lg={12} className={styles.orderMobileLast}>
                <div className={styles.imageWrap}>
                  <img src={about2} alt="Commitment and detail" className={styles.image} />
                </div>
              </Col>
              <Col xs={24} lg={12}>
                <div className={styles.textBlock}>
                  <Title level={3} className={styles.sectionTitle}>
                    Commitment Without Compromise
                  </Title>
                  <Paragraph className={styles.sectionText}>
                    Across generations, our commitment has remained the same — to honour the values of expertise,
                    trust, and uncompromising quality. Every creation is brought to life with meticulous attention
                    to detail, uniting heritage techniques with contemporary design.
                  </Paragraph>
                  <Paragraph className={styles.sectionText}>
                    We hand-select every diamond, scrutinising each stone for its cut, clarity, colour, and carat
                    weight. Only the finest stones make it into our collections — because you deserve nothing less.
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </div>

          {/* Section 3 */}
          <div className={styles.section}>
            <Row gutter={[40, 24]} align="middle">
              <Col xs={24} lg={12}>
                <div className={styles.textBlock}>
                  <Title level={3} className={styles.sectionTitle}>
                    A Global Vision
                  </Title>
                  <Paragraph className={styles.sectionText}>
                    As a UK-based house with a global reach, we are proud to serve clients around the world,
                    offering not only exceptional jewellery but also a promise: that each piece is crafted with
                    sustainability at heart, innovation in spirit, and beauty without end.
                  </Paragraph>
                  <Paragraph className={styles.sectionText}>
                    From bespoke engagement rings to timeless everyday pieces, our collections are designed
                    to celebrate life's most precious moments — accessible, personal, and unforgettable.
                  </Paragraph>
                </div>
              </Col>
              <Col xs={24} lg={12}>
                <div className={styles.imageWrap}>
                  <img src={about3} alt="Global vision" className={styles.image} />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default About;
